module.exports = __webpack_public_path__ + "img/ES01.0a138ae9.svg";